import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

const opts = {
  theme: {
    dark: true,
    themes: {
      dark: {
        primary: '#FF5900',
        secondary: '#9D3700',
        accent: '#FF5900'
      }
    }
  }
}

export default new Vuetify(opts)
